import * as reducerAlerts from './reducers/reducerAlerts';
import * as reducerBreadcrumbs from './reducers/reducerBreadcrumbs';
import * as reducerGitInfo from './reducers/reducerGitInfo';
import * as reducerSearchResults from './reducers/reducerSearchResults';
import * as reducerLogin from './reducers/reducerLogin';
import * as reducerCompanies from './reducers/reducerCompanies';
import * as reducerAdministrations from './reducers/reducerAdministrations';
import * as reducerLicenses from './reducers/reducerLicenses';
import * as reducerModules from './reducers/reducerModules';
import * as reducerWebsites from './reducers/reducerWebsites';
import * as reducerApplications from './reducers/reducerApplications';
import * as reducerApiUsers from './reducers/reducerApiUsers';
import * as reducerTemplates from './reducers/reducerTemplates';
import * as reducerJobs from './reducers/reducerJobs';
import * as reducerPaco from './reducers/reducerPaco';

export function uiStateReducer(state, action) {
    var newState = { ...state };

    switch (action.type) {
        case 'USER_LOGIN_REQUEST':
            newState.authenticationState.loginPending = true;
            break;
        case 'USER_LOGOUT_REQUEST':
            newState.authenticationState.logoutPending = true;
            break;
        case 'LOGGED_IN':
            newState.authenticationState.loginPending = false;
            newState.authenticationState.loggedIn = true;
            newState.authenticationState.loginFailed = false;
            break;
        case 'LOGIN_FAILED':
            newState.authenticationState.loginPending = false;
            newState.authenticationState.loggedIn = false;
            newState.authenticationState.loginFailed = true;
            break;
        case 'LOGGED_OUT':
            newState.authenticationState.loginPending = false;
            newState.authenticationState.logoutPending = false;
            newState.authenticationState.loggedIn = false;
            newState.authenticationState.loginFailed = true;
            break;
        case 'DATA_LOADING':
            newState.componentState = {
                ...state.componentState,
                [action.resource]: { loading: true, loadFailed: false },
            };
            break;
        case 'DATA_LOADED':
            newState.componentState = {
                ...state.componentState,
                [action.resource]: { loading: false },
            };
            break;
        case 'DATA_LOAD_ERROR':
            newState.componentState = {
                ...state.componentState,
                [action.resource]: { loading: false, loadFailed: true },
            };
            break;
        case 'SET_DATA':
            newState.componentState = {
                ...state.componentState,
                [action.resource]: { loading: true, disableForm: true },
            };
            break;
        case 'SET_DATA_SUCCESS':
        case 'SET_DATA_ERROR':
            newState.componentState = {
                ...state.componentState,
                [action.resource]: { loading: false, disableForm: false },
            };
            break;
        default:
        // console.log('uiStateReducer: action not found', action.type);
    }

    return newState;
}

/* this function hold the complete collection of all appData reducer functions,
and controls, by action, which function should be returned */
function reducerControl(state, action) {
    const reducerCollection = {
        alerts: reducerAlerts.appDataReducerAlerts,
        breadcrumbs: reducerBreadcrumbs.appDataReducerBreadcrumbs,
        gitInfo: reducerGitInfo.appDataReducerGitInfo,
        searchResults: reducerSearchResults.AppDataReducerSearchResults,
        login: reducerLogin.appDataReducerLogin,
        companies: reducerCompanies.appDataReducerCompanies,
        company: reducerCompanies.appDataReducerCompany,
        companyNew: reducerCompanies.appDataReducerNewCompany,
        administrations: reducerAdministrations.appDataReducerAdministrations,
        administration: reducerAdministrations.appDataReducerAdministration,
        administrationNew: reducerAdministrations.appDataReducerNewAdministration,
        licenses: reducerLicenses.appDataReducerLicenses,
        license: reducerLicenses.appDataReducerLicense,
        licenseWithAllModules: reducerLicenses.appDataReducerLicensesWithAllModules,
        licenseNewEdit: reducerLicenses.appDataReducerNewEditLicense,
        modules: reducerModules.appDataReducerModules,
        websites: reducerWebsites.appDataReducerWebsites,
        applications: reducerApplications.appDataReducerApplications,
        application: reducerApplications.appDataReducerApplication,
        apiUsers: reducerApiUsers.appDataReducerApiUsers,
        apiUser: reducerApiUsers.appDataReducerApiUser,
        apiUserWithAllRoutingSlugs: reducerApiUsers.appDataReducerApiUserWithAllRoutingSlugs,
        routingSlugs: reducerApiUsers.appDataReducerRoutingSlugs,
        templates: reducerTemplates.AppDataReducerTemplates,
        template: reducerTemplates.AppDataReducerTemplate,
        templateWithAllRoutingSlugs: reducerTemplates.AppDataReducerTemplateWithAllRoutingSlugs,
        runningTasks: reducerJobs.AppDataReducerRunningTasks,
        jobsOverview: reducerJobs.AppDataReducerJobsOverview,
        failedJobs: reducerJobs.AppDataReducerFailedJobs,
        sessionsSourceOverview: reducerPaco.AppDataReducerSessionsSourceOverview,
    };

    if (action[action.dataType] === null) {
        return {};
    }

    return reducerCollection[action.dataType](state, action);
}

export function appDataReducer(state, action) {
    const newState = Object.assign({}, state);

    switch (action.type) {
        case 'SUCCESS':
            newState[action.dataType] = reducerControl(null, action);

            if (action.alert) {
                newState['alerts'] = reducerControl(null, action.alert);
            }
            return newState;
        case 'RESET':
            newState[action.dataType] = false;
            return newState;
        case 'ERROR':
            newState[action.dataType] = reducerControl(null, action);
            return newState;
        case '@@router/LOCATION_CHANGE':
            // TODO I dont think we need this
            newState.alerts = false;
            return newState;
        default:
        //console.log('appDataReducer: action not found', action.type);
    }

    return newState;
}
